:host{
  /*base variables to set other variables (!DO NOT USE IN ELEMENT STYLE)*/
  /*theme color change base on user selected color attribute*/
  --theme-color:var(--jb-button-primary, var(--jb-primary));
  /*--base-color will change in different status like disabled ,...*/
  --base-color: var(--jb-button-base-color, var(--theme-color));
  --base-color-hover: var(--jb-button-base-color-hover, oklch(from var(--base-color) calc(l + 0.07) calc(c + 0.07) h));
  --base-color-pressed: var(--jb-button-base-color-pressed, oklch(from var(--base-color) calc(l - 0.1) calc(c - 0.05) h));
  /* Size */
  --height: var(--jb-button-height, var(--jb-control-height-md, 2.5rem));
  --font-size: var(--jb-button-font-size, 1rem);
  --inline-padding: var(--jb-button-inline-padding, 1rem);
  --block-padding: var(--jb-button-block-padding, 0.5rem);
  --border-radius: var(--jb-button-border-radius, var(--jb-radius));
  --button-icon-size: var(--jb-button-icon-size, 1.5rem);
  --content-gap: var(--jb-button-content-gap, 0.5rem);
  /* Theme/Color */
  --bg-color: var(--jb-button-bg-color,var(--base-color));
  --bg-color-hover: var(--jb-button-bg-color-hover, var(--base-color-hover));
  --bg-color-pressed: var(--jb-button-bg-color-pressed,var(--base-color-pressed));
  --color:var(--jb-button-color, var(--jb-content-inverse));
  --color-hover:var(--jb-button-color-hover, var(--color));
  --color-pressed:var(--jb-button-color-pressed, var(--color));
  --loading-color:var(--jb-button-loading-color, var(--color));
  /**border variables*/
  --border-color: var(--jb-button-border-color, var(--base-color));
  --border-color-hover: var(--jb-button-border-color-hover, var(--base-color-hover));
  --border-color-pressed: var(--jb-button-border-color-pressed, var(--base-color-pressed));
  --border-width: var(--jb-button-border-width, 0);
  /* Other */
  --margin: var(--jb-button-margin, 0 0);
  --box-shadow: var(--jb-button-box-shadow, var(--jb-control-shadow));
  --box-shadow-hover: var(--jb-button-box-shadow-hover, var(--jb-control-shadow-focus));
  --box-corner-shape: var(--jb-corner-shape);
  --border-style: var(--jb-button-border-style, solid);
  --font-weight: var(--jb-button-font-weight, bold);
  --cursor: var(--jb-button-cursor, pointer);
  --text-shadow: var(--jb-button-text-shadow, none);
  --cursor-disabled: var(--jb-button-cursor-disabled, not-allowed);
  --text-shadow-disabled: var(--jb-button-text-shadow-disabled, var(--text-shadow));
}

/* Theme/Color */
:host([color="positive"]){
  --theme-color:var(--jb-button-positive, var(--jb-green))
}
:host([color="danger"]){
  --theme-color: var(--jb-button-danger, var(--jb-red));
}
:host([color="warning"]){
  --theme-color: var(--jb-button-warning, var(--jb-yellow))
}
:host([color="secondary"]){
  --theme-color: var(--jb-button-secondary, var(--jb-secondary))
}
:host([color="light"]){
  --theme-color: var(--jb-button-light, var(--jb-surface-secondary));
  --color:var(--jb-button-color, var(--jb-content-primary));
  --color-hover:var(--jb-neutral);
}
:host([color="dark"]){
  --theme-color: var(--jb-button-dark, var(--jb-neutral));
}

/* states */
:host(:state(disabled)){
  --base-color: var(--jb-button-disabled, hsl(from var(--theme-color) h 12% 66.1));
  --base-color-hover: var(--jb-button-base-color-hover-disabled, var(--base-color));
  --base-color-pressed: var(--jb-button-base-color-pressed-disabled, var(--base-color));
  --color:var(--jb-button-color-disabled, var(--jb-neutral-3));
  --loading-color:var(--jb-button-loading-color-disabled, var(--color));
}

/*variants*/
:host([variant="outline"]){
  --bg-color: var(--jb-button-bg-color-outline, var(--jb-surface-primary));
  --bg-color-hover: var(--jb-button-bg-color-outline-hover, var(--jb-surface-secondary));
  --bg-color-pressed: var(--jb-button-bg-color-outline-pressed, var(--jb-neutral-9));
  --color: var(--jb-button-color-outline, var(--base-color));
  --color-hover: var(--jb-button-color-outline-hover, var(--base-color-hover));
  --color-pressed: var(--jb-button-color-outline-pressed, var(--base-color-pressed));
  --loading-color: var(--jb-button-loading-color-outline, var(--base-color));
  --border-width: var(--jb-button-border-width, 1px);
}
:host([variant="ghost"]){
  --bg-color: var(--jb-button-bg-color-ghost, transparent);
  --bg-color-hover: var(--jb-button-bg-color-ghost-hover, var(--jb-surface-secondary));
  --bg-color-pressed: var(--jb-button-bg-color-ghost-pressed, var(--jb-neutral-9));
  --color: var(--jb-button-color-ghost, var(--base-color));
  --color-hover: var(--jb-button-color-ghost-hover, var(--base-color-hover));
  --color-pressed: var(--jb-button-color-ghost-pressed, var(--base-color-pressed));
  --loading-color: var(--jb-button-loading-color-ghost, var(--base-color));
  --border-width: var(--jb-button-border-width-ghost, 0px);
  --box-shadow: var(--jb-button-box-shadow-ghost, none);
  /* ghost has now box-shadow in  normal and has shadow on focus  */
  --box-shadow-hover: var(--jb-button-box-shadow-hover, var(--jb-control-shadow-focus));;
}
:host([variant="text"]){
  --bg-color: var(--jb-button-bg-color-text, transparent);
  --bg-color-hover: var(--jb-button-bg-color-text-hover, transparent);
  --bg-color-pressed: var(--jb-button-bg-color-text-pressed, transparent);
  --color: var(--jb-button-color-text, var(--base-color));
  --color-hover: var(--jb-button-color-text-hover, var(--base-color-hover));
  --color-pressed: var(--jb-button-color-text-pressed, var(--base-color-pressed));
  --loading-color: var(--jb-button-loading-color-text, var(--base-color));
  --border-width: var(--jb-button-border-width-text, 0px);
   /* text has now box-shadow in both normal and focus  */
  --box-shadow: var(--jb-button-box-shadow-text, none);
  --box-shadow-hover: var(--jb-button-box-shadow-text-hover, none);
}

:host([color="light"][variant="text"]){
  --color: var(--jb-button-color-text, var(--jb-button-color, var(--base-color)));
  --color-hover: var(--jb-button-color-text-hover, var(--jb-button-color-hover, var(--base-color-hover)));
  --color-pressed: var(--jb-button-color-text-pressed, var(--jb-button-color-pressed, var(--base-color-pressed)));
}


/* Size */
:host([size="xs"]){
  --height: var(--jb-button-height-xs, var(--jb-control-height-xs, 1.5rem));
  --font-size: var(--jb-button-font-size-xs, 0.75rem);
  --inline-padding: var(--jb-button-inline-padding-xs, 0.25rem);
  --block-padding: var(--jb-button-block-padding-xs, 0.125rem);
  --border-radius: var(--jb-button-border-radius-xs, var(--jb-radius-xs));
  --button-icon-size: var(--jb-button-icon-size-xs, 1rem);
  --content-gap: var(--jb-button-content-gap-xs, 0.125rem);
}
:host([size="sm"]){
  --height: var(--jb-button-height-sm, var(--jb-control-height-sm, 2rem));
  --font-size: var(--jb-button-font-size-sm, 0.875rem);
  --inline-padding: var(--jb-button-inline-padding-sm, 0.5rem);
  --block-padding: var(--jb-button-block-padding-sm, 0.25rem);
  --border-radius: var(--jb-button-border-radius-sm, var(--jb-radius-sm));
  --button-icon-size: var(--jb-button-icon-size-sm, 1.25rem);
  --content-gap: var(--jb-button-content-gap-sm, 0.25rem);
}
:host([size="lg"]){
  --height: var(--jb-button-height-lg, var(--jb-control-height-lg, 3rem));
  --font-size: var(--jb-button-font-size-lg, 1.125rem);
  --inline-padding: var(--jb-button-inline-padding-lg, 1.5rem);
  --block-padding: var(--jb-button-block-padding-lg, 0.75rem);
  --border-radius: var(--jb-button-border-radius-lg, var(--jb-radius-lg));
  --button-icon-size: var(--jb-button-icon-size-lg, 1.75rem);
  --content-gap: var(--jb-button-content-gap-lg, 0.75rem);
}
:host([size="xl"]){
  --height: var(--jb-button-height-xl, var(--jb-control-height-xl, 4rem));
  --font-size: var(--jb-button-font-size-xl, 1.25rem);
  --inline-padding: var(--jb-button-inline-padding-xl, 2rem);
  --block-padding: var(--jb-button-block-padding-xl, 1rem);
  --border-radius: var(--jb-button-border-radius-xl, var(--jb-radius-xl));
  --button-icon-size: var(--jb-button-icon-size-xl, 2.25rem);
  --content-gap: var(--jb-button-content-gap-xl, 1rem);
}
:host([square]){
  --inline-padding: var(--block-padding);
}
/* Combined situation */

:host(:state(disabled)[variant="outline"]){
  --color: var(--jb-button-color-outline-disabled, var(--base-color));
  --loading-color: var(--jb-button-loading-color-outline-disabled, var(--color));
  --bg-color-hover: var(--jb-button-bg-color-outline-hover-disabled, var(--bg-color));
  --bg-color-pressed: var(--jb-button-bg-color-outline-pressed-disabled, var(--bg-color));
}

:host([color="light"][variant="ghost"]),
:host([color="light"][variant="outline"]){
  --base-color-hover:var(--jb-neutral-4);
  --loading-color-hover:var(--jb-neutral-4);
  /*formula must be the same but its's base on --base-color-hover*/
  --base-color-pressed: var(--jb-button-base-color-pressed-light, oklch(from var(--base-color-hover) calc(l - 0.1) calc(c - 0.05) h));
}